import React from "react";
import { Link } from "react-router-dom";
import { AppStoreBadge } from "../features/public/components/AppStoreBadge";
import { revokeConsent } from "../services/cookieConsent";

const IOS_URL = "https://apps.apple.com/it/app/giojoy/id6760832987";
const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.giojoy.app";

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white py-8">
      <div className="mx-auto max-w-4xl px-4">
        <div className="flex flex-col items-center gap-4 text-sm text-gray-500">
          <p className="text-xs font-semibold uppercase tracking-widest text-gray-400">
            Scarica l'app
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <AppStoreBadge store="ios" href={IOS_URL} />
            <AppStoreBadge store="android" href={ANDROID_URL} />
          </div>
          <div className="mt-2 flex flex-col items-center gap-1">
            <p>© 2026 GioJoy, Tutti i diritti riservati.</p>
            <p>P.IVA IT12092120018</p>
          </div>
          <div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-6">
            <Link to="/privacy-policy" className="hover:text-gray-900 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/cookie-policy" className="hover:text-gray-900 transition-colors">
              Cookie Policy
            </Link>
            <Link to="/terms" className="hover:text-gray-900 transition-colors">
              Termini d'uso
            </Link>
            <button
              type="button"
              onClick={revokeConsent}
              className="hover:text-gray-900 hover:underline transition-colors"
            >
              Preferenze Cookie
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
